import React from 'react';

import connectStore from 'decorators/connectStore';
import AccountStore from 'stores/AccountStore';
import I18nStore from 'stores/I18nStore';

import StatefulLanguagePicker from 'components/nav/shared/StatefulLanguagePicker';

@connectStore(AccountStore, 'accountState')
@connectStore(I18nStore, 'i18nState')
class LanguagePickerContainer extends React.Component {
  render() {
    return (
      <StatefulLanguagePicker {...this.props} />
    );
  }
}

export default LanguagePickerContainer;
